import { render } from "./AddressCardOfNei.vue?vue&type=template&id=2c5eef14&scoped=true"
import script from "./AddressCardOfNei.vue?vue&type=script&lang=ts"
export * from "./AddressCardOfNei.vue?vue&type=script&lang=ts"

import "./AddressCardOfNei.vue?vue&type=style&index=0&id=2c5eef14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c5eef14"

export default script